import { Component, computed } from 'vue';

import ProductReviews from '@/components/ProductReviews/ProductReviews.vue';
import { createCoreVueApp } from '@/entrypoints/shared/core-vue-app';
import { mountProductTab } from '@/entrypoints/shared/tab-mounter';
import { openLoginModal } from '@/shared/instances/login-modal';
import { useUserStore } from '@/shared/pinia/modules/user';
import { contextualError } from '@/shared/utils/error';

const mountSelector = '#js-product-reviews';
const boundTabSelector = '#tab-reviews';

const getProps = () => {
  const target = document.querySelector<HTMLElement>(mountSelector);

  if (!target)
    throw contextualError('product-reviews', `Element "${target}" not found.`);

  const { reviewData } = target.dataset;

  if (reviewData) {
    const data = JSON.parse(reviewData);

    return {
      reviewCount: data.review_count,
      averageRatingScore: data.average_review_score
    };
  }

  return {
    reviewCount: 0,
    averageRatingScore: 0
  };
};

const mounter = async (
  component: Component,
  target: HTMLElement,
  props?: Record<string, unknown>
) => {
  const userStore = useUserStore();
  const profile = computed(() => userStore.communityProfile);

  const coreApp = await createCoreVueApp(component, target, props);
  coreApp
    .provide('profile', profile)
    .provide('initLogin', openLoginModal)
    .mount(target);
};

mountProductTab(
  ProductReviews,
  mountSelector,
  boundTabSelector,
  mounter,
  getProps()
);
